import React from "react";
import "./EditProfileButton.css";
import editLogo from "../../img/vector-5-black.svg";
import right4 from "../../img/right-4@2x.svg";
import Link from "../Link";


const EditProfileButton = (props) => {
    const { className, logo } = props;

    return (
        <div className="edit-profile-button-2">
            <Link href="/profile">
                <img className="vector-70" src={`${logo || editLogo}`}></img>
                <div className={`edit-profile-5 ${className || "nunito-bold-black-14px"}`}>Edit Profile</div>
                <img className="right-48" src={right4} />
            </Link>
        </div>
    )
}

export default EditProfileButton;